import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('infantry_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('infantry_token');
      localStorage.removeItem('infantry_user');
      if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/signup') && window.location.pathname !== '/') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;

// Endpoints
export const authApi = {
  signup: (data) => api.post('/auth/signup', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

export const clientsApi = {
  list: () => api.get('/clients'),
  create: (data) => api.post('/clients', data),
  get: (id) => api.get(`/clients/${id}`),
  update: (id, data) => api.patch(`/clients/${id}`, data),
  delete: (id) => api.delete(`/clients/${id}`),
};

export const itemsApi = {
  delete: (id) => api.delete(`/negative-items/${id}`),
};

export const documentsApi = {
  upload: (clientId, file, type = 'credit_report', bureau = null) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('type', type);
    if (bureau) fd.append('bureau', bureau);
    return api.post(`/clients/${clientId}/documents`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  delete: (id) => api.delete(`/documents/${id}`),
  fileUrl: (id) => {
    const token = localStorage.getItem('infantry_token');
    return `${API_BASE}/documents/${id}/file?token=${encodeURIComponent(token || '')}`;
  },
};

export const aiApi = {
  analyze: (clientId) => api.post(`/clients/${clientId}/analyze`),
  getAnalyzeJob: (clientId, jobId) => api.get(`/clients/${clientId}/analyze/job/${jobId}`),
  insights: (clientId) => api.post(`/clients/${clientId}/insights`),
  getInsights: (clientId) => api.get(`/clients/${clientId}/insights`),
  getInsightsJob: (clientId, jobId) => api.get(`/clients/${clientId}/insights/job/${jobId}`),
  insightsPdfUrl: (clientId) => {
    const token = localStorage.getItem('infantry_token');
    return `${API_BASE}/clients/${clientId}/insights/pdf?token=${encodeURIComponent(token || '')}`;
  },
  createInsightsShare: (clientId) => api.post(`/clients/${clientId}/insights/share`),
  revokeInsightsShare: (clientId) => api.post(`/clients/${clientId}/insights/share/revoke`),
  emailInsights: (clientId, payload) => api.post(`/clients/${clientId}/insights/email`, payload),
};

export const disputesApi = {
  list: () => api.get('/disputes'),
  create: (clientId, data) => api.post(`/clients/${clientId}/disputes`, data),
  get: (id) => api.get(`/disputes/${id}`),
  pdfUrl: (id) => `${API_BASE}/disputes/${id}/pdf`,
};

export const statsApi = {
  stats: () => api.get('/stats'),
  activity: () => api.get('/activity'),
};

export const billingApi = {
  summary: () => api.get('/billing/summary'),
  checkout: () => api.post('/billing/checkout', { origin_url: window.location.origin }),
  checkoutStatus: (sessionId) => api.get(`/billing/checkout/status/${sessionId}`),
  portal: () => api.post('/billing/portal', { origin_url: window.location.origin }),
  cancel: () => api.post('/billing/cancel'),
};

export const adminApi = {
  overview: () => api.get('/admin/overview'),
  companies: () => api.get('/admin/companies'),
  activity: (limit = 50) => api.get(`/admin/activity?limit=${limit}`),
  signups: (days = 30) => api.get(`/admin/signups?days=${days}`),
  revenue: (days = 30) => api.get(`/admin/revenue?days=${days}`),
  companyDetail: (userId) => api.get(`/admin/companies/${userId}`),
  clientDetail: (userId, clientId) => api.get(`/admin/companies/${userId}/clients/${clientId}`),
  deleteCompany: (userId) => api.delete(`/admin/companies/${userId}`),
  deleteClient: (userId, clientId) => api.delete(`/admin/companies/${userId}/clients/${clientId}`),
  updateCompany: (userId, data) => api.patch(`/admin/companies/${userId}`, data),
};
